export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const CLEAR_USER_EMAIL = 'CLEAR_USER_EMAIL';